/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';

export default class UiColorPickerComponent extends Component {
  @service intl;

  @tracked color = this.args.color || '';
  @tracked picker;

  get template() {
    let verticalPlacement = this.args.verticalPlacement || 'top';
    return `
        <div class="picker_wrapper layout_default ${verticalPlacement}" tabindex="-1">
            <div class="picker_hue picker_slider">
                <div class="picker_selector"></div>
            </div>
            <div class="picker_sl">
                <div class="picker_selector"></div>
            </div>
            <div class="picker_alpha picker_slider">
                <div class="picker_selector"></div>
            </div>
            <div class="picker_editor">
                <input aria-label="${this.intl.t('ui.color-picker.color-name-or-hex')}">
            </div>
            <div class="picker_sample"></div>
            <div class="picker_cancel rounded inline-flex items-center font-medium focus-visible:outline-none select-none border border-secondary bg-white active:bg-gray-light hover:bg-gray-lightest border-b-2 active:border-b active:translate-y-px focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary">
                <button name="cancel-color-selection" class="">${this.intl.t('global.cancel')}</button>
            </div>
						<div class="picker_done ember-view inline-flex items-center font-medium focus-visible:outline-none select-none border border-secondary bg-primary hover:bg-primary-dark border-b-2 active:border-b active:translate-y-px rounded focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary">
                <button name="save-color-selection">${this.intl.t('global.save')}</button>
            </div>
        </div>
    `;
  }

  @action
  saveApi(picker) {
    this.picker = picker;
  }

  @action
  openPicker() {
    this.picker.show();
  }

  @action
  onDone(color) {
    if (this.args.alpha) {
      this.color = color.hex;
    } else {
      this.color = color.printHex(false);
    }
    this.args.onDone(color.hex);
    this.picker.destroy();
  }

  @action
  clearColor() {
    this.color = '';
    this.args.onDone('');
    this.picker.destroy();
  }
}
